import { EventEmitter, Injectable, Output } from '@angular/core';
import { Http } from '@angular/http';
import { ParentService } from '../../pages/A2-utils/ParentClass/ParentService';
import { constant } from '../../app.constants';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SsnService extends ParentService {

  @Output() disabledInput = new EventEmitter();
  @Output() isInvalid = new EventEmitter();
  constructor(private _http: Http) {
    super();
  }

  getSsnOndemand(userProfileId: number) {
    const url = `${constant.URL_ONDEMAND_DRIVERS}/Ssn/${userProfileId}`;
    return this._http.get(url, this.getHeader())
      .map(res => res.json())
      .catch(err => Observable.throw(err.json()));
  }

  updateSsnOndemand(id, ssn) {
    const url = `${constant.URL_ONDEMAND_DRIVERS}/UpdateSsn`;
    return this._http.put(url, { id, ssn }, this.headerPost())
      .map(res => res.json())
      .catch(err => Observable.throw(err.json()));
  }

  getSsnMctDriver(userProfileId: number) {
    const url = `${constant.URL_DRIVERS}/Ssn/${userProfileId}`;
    return this._http.get(url, this.getHeader())
      .map(res => res.json())
      .catch(err => Observable.throw(err.json()));
  }

  updateSsnMctDriver(id, ssn) {
    const url = `${constant.URL_DRIVERS}/UpdateSsn`;
    return this._http.put(url, { id, ssn }, this.headerPost())
      .map(res => res.json())
      .catch(err => Observable.throw(err.json()));
  }


  getSsnRider(id: number) {
    const url = `${constant.RIDER.BASE}/Ssn/${id}`;
    return this._http.get(url, this.getHeader())
      .map(res => res.json())
      .catch(err => Observable.throw(err.json()));
  }

  updateSsnRider(id, ssn) {
    const url = `${constant.RIDER.BASE}/UpdateSsn`;
    return this._http.put(url, { id, ssn }, this.headerPost())
      .map(res => res.json())
      .catch(err => Observable.throw(err.json()));
  }


}



// WEBPACK FOOTER //
// ./src/app/utils/ssn-module/ssn.service.ts